import React, { useRef } from "react";

import { useReactToPrint } from "react-to-print";

const ExtraDutyLogsheet = ({
  data,
  data1,
  data2,
  isDrv,
  isCond,
  isPresent,
  currentIndex,
}) => {
  const componentRef = useRef();

  const rows = Array.from({ length: 12 }, (_, i) => i + 1);

  const convertToMarNos = (engNo) => {
    const marNos = {
      0: "०",
      1: "१",
      2: "२",
      3: "३",
      4: "४",
      5: "५",
      6: "६",
      7: "७",
      8: "८",
      9: "९",
    };
    return (
      engNo &&
      engNo
        .toString()
        .split("")
        .map((num) => marNos[num] || num)
        .join("")
    );
  };

  const handleAfterPrint = React.useCallback(() => {
    // console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    // console.log("`onBeforePrint` called");
    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "AwesomeFileName",
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  return (
    <>
      <div className="a4-page" ref={componentRef}>
        <table className="header">
          <tr>
            <td className="left"></td>
            <td>परिवहन सेवा, ठाणे महानगरपालिका ठाणे</td>
            <td className="right"></td>
          </tr>
          <tr>
            <td className="left">मार्ग क्र {convertToMarNos(data.workno && data.workno.split("/")[0])}{" "}</td>
            <td>बसफेरी व किलोमीटर पत्रक</td>
            <td className="right">दिनांक :</td>
          </tr>
          <tr>
            <td className="left">
              जादा {convertToMarNos(data.workno && data.workno.split("/")[1])}{" "}
            </td>
            <td style={{ fontSize: "24px", fontWeight: "600" }}>
              जादा फेरीपत्रक
            </td>
            <td className="right">
              चालक क्रमांक : {convertToMarNos(data && data.driverNo)}
            </td>
          </tr>
          <tr>
            <td className="left"></td>
            <td>कळवा आगार वाहतूक {convertToMarNos(25425193)}</td>
            <td className="right">
              वाहक क्रमांक : {convertToMarNos(data && data.conductorNo)}
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              {" "}
              <div className="newcflex mb-1">
                <span>
                  कळवा आगार दुरुस्ती पथक {convertToMarNos(9821239702)}
                </span>
                <span> कळवा आगार कार्यशाळा {convertToMarNos(9821239728)}</span>
              </div>
              <div className="newcflex mb-1">
                <span>
                  वागळे आगार दुरुस्ती पथक {convertToMarNos(9821239761)}
                </span>
                <span>
                  {convertToMarNos(9821239745)}, {convertToMarNos(9821239736)}
                </span>
              </div>
              <div className="newcflex mb-1">
                <span>टोल फ्री - {convertToMarNos(1800229901)}</span>
                <span>फोन नं. {convertToMarNos(25827785)}</span>
              </div>
            </td>
          </tr>
        </table>

        {/* <div className="header-flex">
          <div className="custom-flex">
            <div
              className="center"
              style={{
                width: "800px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>परिवहन सेवा, ठाणे महानगरपालिका ठाणे</span>
            </div>
          </div>
          <div className="custom-flex">
            <div className="left" style={{ width: "150px" }}>
              <span>मार्ग क्र</span>
            </div>
            <div className="center">
              <span>बसफेरी व किलोमीटर पत्रक</span>
            </div>
            <div className="right" style={{ width: "150px" }}>
              <span>दिनांक :</span>
            </div>
          </div>
          <div className="custom-flex">
            <div className="left" style={{ width: "150px" }}>
              <span>जादा</span>
            </div>
            <div
              className="center"
              style={{ fontSize: "24px", fontWeight: "600" }}
            >
              <span>जादा फेरीपत्रक</span>
            </div>
            <div className="right" style={{ width: "150px" }}>
              <span>चालक क्रमांक :</span>
            </div>
          </div>
          <div className="custom-flex">
            <div className="left" style={{ width: "150px" }}>
              <span></span>
            </div>
            <div className="center">
              <span>कळवा आगार वाहतूक {convertToMarNos(25425193)} </span>
            </div>
            <div className="right" style={{ width: "150px" }}>
              <span>वाहक क्रमांक :</span>
            </div>
          </div>
          <div style={{ width: "800px" }}>
            <div className="newcflex">
              <span>कळवा आगार दुरुस्ती पथक {convertToMarNos(9821239702)}</span>
              <span>कळवा आगार कार्यशाळा {convertToMarNos(9821239728)}</span>
            </div>
          </div>
          <div style={{ width: "800px" }}>
            <div className="newcflex">
              <span>
                वागळे आगार दुरुस्ती पथक {convertToMarNos(9821239761)}{" "}
              </span>
              <span>
                {convertToMarNos(9821239745)}, {convertToMarNos(9821239736)}{" "}
              </span>
            </div>
          </div>

          <div style={{ width: "800px" }}>
            <div className="newcflex">
              <span>टोल फ्री - {convertToMarNos(1800229901)}</span>
              <span>फोन नं. {convertToMarNos(25827785)}</span>
            </div>
          </div>
        </div> */}

        <div className="mt-3 ms-5" style={{ width: "650px" }}>
          <table className="table table1">
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>बस क्र.</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>
                बस बदलीची वेळ
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
        <div className="" style={{ width: "785px" }}>
          <table>
            <thead>
              <tr>
                <td>अ क्र</td>
                <td colSpan={2}>मार्ग</td>
                <td>नियत</td>
                <td>बस प्रत्यक्ष</td>
                <td>नियत</td>
                <td>प्रत्यक्ष</td>
                <td>शेरा व वाह.</td>
              </tr>
              <tr>
                <td></td>
                <td className="colspan">पासून</td>
                <td>पर्यंत</td>
                <td>किमी</td>
                <td>आगमन</td>
                <td>वेळ</td>
                <td>निर्गमन</td>
                <td>नियं सही</td>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(rows) &&
                rows.map((item, i) => {
                  return (
                    <>
                      <tr>
                        <td>{convertToMarNos(i + 1)}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div className="mt-3" style={{ width: "785px" }}>
          <span>
            वाहतूक नियंत्रकांना सूचना :- आवश्यकते नुसार गर्दीच्या मार्गावर
            फिरविणे तसेच नियमा नुसार चालक/वाहकांना विश्रांती द्यावी
          </span>
        </div>
      </div>
      {isDrv &&
      (data.driverPresenty === "1" ||
        data1.length > 0 ||
        isPresent) ? (
        <>
          <button className="action print active" onClick={(e) => printFn()}>
            <span>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.95837 3.95817C3.95837 3.52095 4.31282 3.1665 4.75004 3.1665H14.25C14.6873 3.1665 15.0417 3.52095 15.0417 3.95817V8.70817C16.3534 8.70817 17.4167 9.77146 17.4167 11.0832V14.2498C17.4167 15.5615 16.3534 16.6248 15.0417 16.6248H3.95837C2.64669 16.6248 1.58337 15.5615 1.58337 14.2498V11.0832C1.58337 9.77146 2.6467 8.70817 3.95837 8.70817V3.95817ZM3.95837 10.2915C3.52115 10.2915 3.16671 10.6459 3.16671 11.0832V14.2498C3.16671 14.6871 3.52115 15.0415 3.95837 15.0415H15.0417C15.4789 15.0415 15.8334 14.6871 15.8334 14.2498V11.0832C15.8334 10.6459 15.4789 10.2915 15.0417 10.2915V11.8748C15.0417 12.3121 14.6873 12.6665 14.25 12.6665H4.75004C4.31282 12.6665 3.95837 12.3121 3.95837 11.8748V10.2915ZM5.54171 4.74984V9.49984V11.0832H13.4584V9.49984V4.74984H5.54171ZM7.12504 7.12484C7.12504 6.68762 7.47949 6.33317 7.91671 6.33317H11.0834C11.5206 6.33317 11.875 6.68762 11.875 7.12484C11.875 7.56206 11.5206 7.9165 11.0834 7.9165H7.91671C7.47949 7.9165 7.12504 7.56206 7.12504 7.12484ZM7.12504 9.49984C7.12504 9.0626 7.47949 8.70817 7.91671 8.70817H11.0834C11.5206 8.70817 11.875 9.0626 11.875 9.49984C11.875 9.93707 11.5206 10.2915 11.0834 10.2915H7.91671C7.47949 10.2915 7.12504 9.93707 7.12504 9.49984Z"
                  fill="var(--primary-color)"
                />
              </svg>
            </span>
          </button>
        </>
      ) : isCond &&
        (data.conductorPresenty === "1" ||
          data2.length > 0 ||
          isPresent) ? (
        <>
          <button className="action print active" onClick={(e) => printFn()}>
            <span>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.95837 3.95817C3.95837 3.52095 4.31282 3.1665 4.75004 3.1665H14.25C14.6873 3.1665 15.0417 3.52095 15.0417 3.95817V8.70817C16.3534 8.70817 17.4167 9.77146 17.4167 11.0832V14.2498C17.4167 15.5615 16.3534 16.6248 15.0417 16.6248H3.95837C2.64669 16.6248 1.58337 15.5615 1.58337 14.2498V11.0832C1.58337 9.77146 2.6467 8.70817 3.95837 8.70817V3.95817ZM3.95837 10.2915C3.52115 10.2915 3.16671 10.6459 3.16671 11.0832V14.2498C3.16671 14.6871 3.52115 15.0415 3.95837 15.0415H15.0417C15.4789 15.0415 15.8334 14.6871 15.8334 14.2498V11.0832C15.8334 10.6459 15.4789 10.2915 15.0417 10.2915V11.8748C15.0417 12.3121 14.6873 12.6665 14.25 12.6665H4.75004C4.31282 12.6665 3.95837 12.3121 3.95837 11.8748V10.2915ZM5.54171 4.74984V9.49984V11.0832H13.4584V9.49984V4.74984H5.54171ZM7.12504 7.12484C7.12504 6.68762 7.47949 6.33317 7.91671 6.33317H11.0834C11.5206 6.33317 11.875 6.68762 11.875 7.12484C11.875 7.56206 11.5206 7.9165 11.0834 7.9165H7.91671C7.47949 7.9165 7.12504 7.56206 7.12504 7.12484ZM7.12504 9.49984C7.12504 9.0626 7.47949 8.70817 7.91671 8.70817H11.0834C11.5206 8.70817 11.875 9.0626 11.875 9.49984C11.875 9.93707 11.5206 10.2915 11.0834 10.2915H7.91671C7.47949 10.2915 7.12504 9.93707 7.12504 9.49984Z"
                  fill="var(--primary-color)"
                />
              </svg>
            </span>
          </button>
        </>
      ) : (
        <>
          <button className="action print">
            <span>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.95837 3.95817C3.95837 3.52095 4.31282 3.1665 4.75004 3.1665H14.25C14.6873 3.1665 15.0417 3.52095 15.0417 3.95817V8.70817C16.3534 8.70817 17.4167 9.77146 17.4167 11.0832V14.2498C17.4167 15.5615 16.3534 16.6248 15.0417 16.6248H3.95837C2.64669 16.6248 1.58337 15.5615 1.58337 14.2498V11.0832C1.58337 9.77146 2.6467 8.70817 3.95837 8.70817V3.95817ZM3.95837 10.2915C3.52115 10.2915 3.16671 10.6459 3.16671 11.0832V14.2498C3.16671 14.6871 3.52115 15.0415 3.95837 15.0415H15.0417C15.4789 15.0415 15.8334 14.6871 15.8334 14.2498V11.0832C15.8334 10.6459 15.4789 10.2915 15.0417 10.2915V11.8748C15.0417 12.3121 14.6873 12.6665 14.25 12.6665H4.75004C4.31282 12.6665 3.95837 12.3121 3.95837 11.8748V10.2915ZM5.54171 4.74984V9.49984V11.0832H13.4584V9.49984V4.74984H5.54171ZM7.12504 7.12484C7.12504 6.68762 7.47949 6.33317 7.91671 6.33317H11.0834C11.5206 6.33317 11.875 6.68762 11.875 7.12484C11.875 7.56206 11.5206 7.9165 11.0834 7.9165H7.91671C7.47949 7.9165 7.12504 7.56206 7.12504 7.12484ZM7.12504 9.49984C7.12504 9.0626 7.47949 8.70817 7.91671 8.70817H11.0834C11.5206 8.70817 11.875 9.0626 11.875 9.49984C11.875 9.93707 11.5206 10.2915 11.0834 10.2915H7.91671C7.47949 10.2915 7.12504 9.93707 7.12504 9.49984Z"
                  fill="rgba(167, 158, 183, 1)"
                />
              </svg>
            </span>
          </button>
        </>
      )}
    </>
  );
};

export default ExtraDutyLogsheet;
